
export enum CertificateHandlingType {
    None = 0,
    ByAward = 1,
}